import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input, Modal, Tooltip } from '../../root/components/common'
import InitialSearchIcon from './icons/initial-search-icon'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { TableVirtualized } from '../../root/components/common/table-virtualized/table'

import { NavLink, useHistory, useLocation } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import { mdiAccountArrowLeftOutline, mdiAccountCircleOutline } from '@mdi/js'
import MdiIcon from '@mdi/react'
import { useState } from 'react'
import { useQuery } from 'react-query'
import {
    assingUserToLocation,
    getLocationAssignedUsers
} from '../api/locations-api'
import NoSearchResults from './icons/no-search-results'
import { Highlighted } from '../../root/components/common/highlighted'
import { enqueueSnackbar } from '../../root/actions'
import { getSagasMsgs } from '../../root/selectors'
import { UserPermissions } from 'web/src/services/permissions'
import * as locationsActions from '../../locations/actions'
import { getRoleName } from 'web/src/utils'

export const ShareLocationModal = props => {
    const {
        onClose,
        modalProps: { open },
        locationId
    } = props
    const styles = useStyles()
    const { locale, theme } = useSelector(state => state.main)
    const sagasMsgs = useSelector(getSagasMsgs)
    const location = useLocation()
    const emailFromUrl = new URLSearchParams(location.search).get('email')
    const [search, setSearch] = useState(emailFromUrl)
    const { data, isLoading } = useQuery(
        ['assignedUsers', locationId, search],
        () =>
            getLocationAssignedUsers(locationId, {
                search,
                is_assigned: false
            }),
        { refetchInterval: 0 }
    )
    const dispatch = useDispatch()
    const history = useHistory()

    const handleClose = () => {
        onClose()
        history.replace({
            search: ''
        })
        setSearch('')
    }
    const handleOpenNewUser = () => {
        const paramsObj = {
            newUser: true,
            returnUrl: `${location.pathname}?isShare=1`,
            email: search,
            isFLA: true
        }

        const params = new URLSearchParams(paramsObj)
        history.push(`/user-management?${params.toString()}`)
    }

    const columns = [
        {
            key: 'user-icon',
            label: null,
            sortable: false,
            dataType: 'custom',
            width: 0.4,
            render: ({ rowData, cellData }) => {
                if (rowData.is_external) {
                    return (
                        <Tooltip
                            hover
                            placement="top"
                            text={locale.userManagement.externalUser}>
                            <MdiIcon
                                path={mdiAccountArrowLeftOutline}
                                size={'20px'}
                                color={theme.quaternary}
                            />
                        </Tooltip>
                    )
                }
                return (
                    <Tooltip
                        hover
                        placement="top"
                        text={locale.userManagement.internalUser}>
                        <MdiIcon
                            path={mdiAccountCircleOutline}
                            size={'20px'}
                            color={theme.primary}
                        />
                    </Tooltip>
                )
            }
        },
        {
            key: 'name',
            label: locale.common.name,
            // sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData, cellData }) =>
                UserPermissions.isUserMgmtGranted() ? (
                    <NavLink
                        target={'_blank'}
                        className={styles.userNameLink}
                        to={`/user-management/users/${rowData.id}`}>
                        <Highlighted text={cellData} highlight={search} />
                    </NavLink>
                ) : (
                    <Highlighted text={cellData} highlight={search} />
                )
        },
        {
            key: 'email',
            label: locale.common.email,
            // sortable: true,
            width: 1.5,
            dataType: 'string',
            render: ({ rowData, cellData }) => {
                return <Highlighted text={cellData} highlight={search} />
            }
        },
        {
            key: 'role_code',
            label: locale.userManagement.roleName,
            // sortable: true,
            width: 1.5,
            dataType: 'string',
            render: ({ rowData, cellData }) => {
                return getRoleName({
                    name: rowData.role_name,
                    code: rowData.role_code
                }, locale)
            }
        },
        {
            key: 'actions',
            label: locale.userManagement.actions,
            sortable: false,
            dataType: 'custom',
            width: 1.5,
            alignCenter: true,
            render: ({ rowData, cellData }) => {
                return (
                    <div className={styles.actions}>
                        <Tooltip hover placement="top" text={''}>
                            <IconButton
                                size="small"
                                onClick={() => onAddUser(rowData.id)}>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                )
            }
        }
    ]

    const onAddUser = id => {
        assingUserToLocation(locationId, { users: [id] })
            .then(r => {
                dispatch(locationsActions.locationsRequest())
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.shareLocationRes,
                        options: {
                            variant: 'success'
                        }
                    })
                )
                handleClose()
            })
            .catch(e => {
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.shareLocationEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            })
    }

    return (
        <Modal size="xl" className={styles.modal} onClose={onClose} open={open}>
            <div className={styles.root}>
                <div className={styles.header}>
                    <span className={styles.title}>
                        {locale.locations.searchUser}
                    </span>
                    <div className={styles.btn}>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
                <div className={styles.content}>
                    <Input
                        autoFocus
                        label={locale.common.search}
                        type="text"
                        className={styles.search}
                        value={search}
                        setValue={setSearch}
                        debounce={300}
                    />
                    {!search && <InitialSearchIcon />}
                    {search && (
                        <div className={styles.resultsTable}>
                            {data?.length || isLoading ? (
                                <TableVirtualized
                                    data={data}
                                    isLoading={isLoading}
                                    columns={columns}
                                />
                            ) : (
                                <div className={styles.noResults}>
                                    <NoSearchResults />
                                    {locale.locations.userNotFound}
                                    {UserPermissions.isUserMgmtGranted() && (
                                        <Button
                                            onClick={handleOpenNewUser}
                                            className={styles.createNewUserBtn}>
                                            {locale.userManagement.createNew}
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}

const useStyles = makeStyles(theme => ({
    createNewUserBtn: {
        marginTop: 16
    },
    noResults: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    resultsTable: {
        height: 500,
        width: '100%',
        padding: '0 32px 20px 32px'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 60
    },
    root: {
        minHeight: '90vh',
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    modal: {
        padding: 0
    },
    header: {
        paddingTop: '18px',
        paddingBottom: '18px',
        padding: '18px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: theme.border
    },
    title: {
        width: 150
    },
    btn: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: 150
    },
    search: {
        width: '30%',
        marginBottom: 60
    },
    userNameLink: {
        color: theme.textPrimary,
        textDecoration: 'none',
        fontWeight: 'bold',
        cursor: 'pointer'
    }
}))
